import AOS from 'aos';

// smaller screenwidths needs earlier animation
if($(window).width() < 992) {
    $(window).on('load', function() {
        AOS.init({
            once: true,
            offset: 150,
        });
    });
}else{
    $(window).on('load', function() {
        AOS.init({
            once: true,
            offset: 300,
        });
    });
}

AOS.refresh(true);

// set transition delay to zero
$(document).on('mouseover', '.aos-animate.aos-init', function () {
  $(this).addClass('aos-animation-ready');
});
